<app-http-error
  [header]="'HTTP_ERROR.403.HEADER'"
  [body]="'HTTP_ERROR.403.BODY'"
  [http-error]="'403'"
></app-http-error>
